import { MaskedLines, Overline, Reveal, Section } from "./ui";

const steps = [
  {
    n: "01",
    title: "Conte o que aconteceu",
    text: "Informe se o problema é agenda, caixa, tempo livre, cliente, recepção ou outra situação operacional.",
  },
  {
    n: "02",
    title: "O MOM escolhe a missão",
    text: "O sistema cruza situação, tempo disponível, prioridade e contexto para escolher uma missão compatível.",
  },
  {
    n: "03",
    title: "Você executa",
    text: "Receba o que fazer, como fazer, quanto tempo leva e o ponto exato em que a missão termina.",
  },
];

export default function Method() {
  return (
    <Section id="metodo" tone="white">
      <div className="text-center">
        <Overline>Como funciona</Overline>
        <MaskedLines
          inView
          as="h2"
          className="mx-auto mt-5 max-w-2xl font-serif text-3xl font-medium leading-[1.15] tracking-tight text-hc-ink sm:text-4xl lg:text-5xl"
          lines={["3 passos para parar de", <em key="d" className="italic text-mom-carmim">decidir tudo do zero</em>]}
        />
      </div>

      <div className="mt-16 grid grid-cols-1 gap-4 md:grid-cols-3">
        {steps.map((s, i) => (
          <Reveal
            key={s.n}
            delay={i * 0.1}
            className="group flex flex-col rounded-3xl bg-white p-10 shadow-[0_20px_60px_rgba(0,0,0,0.05)] transition-transform duration-500 hover:-translate-y-1"
          >
            <span className="bg-gradient-to-br from-mom-vinho to-mom-carmim bg-clip-text font-serif text-6xl font-semibold leading-none text-transparent">
              {s.n}
            </span>
            <h3 className="mt-8 font-serif text-xl font-semibold text-hc-ink">
              {s.title}
            </h3>
            <p className="mt-3 font-dmsans text-sm leading-relaxed text-hc-mutedInk">
              {s.text}
            </p>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
